
import { httpClient, setResponseType } from '@/app/shared/services';
import { apiConstants } from '../config';

const URL = apiConstants.home;
const TOWN =  apiConstants.town;
const PROVINCES =  apiConstants.provinces;
const GROUPS_URL = apiConstants.group;
const PHONE_PREFIX = apiConstants.phonePrefix;
const URL_INVOICE = apiConstants.invoices;


const fetchAllData = (page = null, filtro = '') => {
  let filter = filtro.length > 0 ? filtro : "";

  if (page != null) {
    return httpClient.get(`${URL}?page=${page}${filter}`).then(res => res.data)
  }
  else {
    return httpClient.get(`${URL}?${filter}`).then(res => res.data)
  }
};

const fetchAllTown = (page = null, filtro = '') => {
  let filter = filtro.length > 0 ? filtro : "";

  if (page != null) {
    return httpClient.get(`${TOWN}?page=${page}${filter}`).then(res => res.data)
  }
  else {
    return httpClient.get(`${TOWN}?${filter}`).then(res => res.data)
  }
};

const fetchOneTown = (id) => {
  return httpClient.get(`${TOWN}/${id}`).then(res => res.data);
};


const fetchAllProvince = (page = null, filtro = '') => {
  let filter = filtro.length > 0 ? filtro : "";

  if (page != null) {
    return httpClient.get(`${PROVINCES}?page=${page}${filter}`).then(res => res.data)
  }
  else {
    return httpClient.get(`${PROVINCES}?${filter}`).then(res => res.data)
  }
};

const fetchOneProvince = (id) => {
  return httpClient.get(`${PROVINCES}/${id}`).then(res => res.data);
};

const fetchAllParkings = (filtro = '') => {
  let filter = filtro.length > 0 ? filtro : "";

  return httpClient.get(`${apiConstants.parking}?${filter}`).then(res => res.data);

};


const fetchAllGroups = (page = null, filtro = '') => {
  let filter = filtro.length > 0 ? filtro : "";

  if (page != null) {
    return httpClient.get(`${GROUPS_URL}?page=${page}${filter}`).then(res => res.data)
  }
  else {
    return httpClient.get(`${GROUPS_URL}?${filter}`).then(res => res.data)
  }
};


const fetchAllPhonePrefix = () => {
  return httpClient.get(`${PHONE_PREFIX}`).then(res => res.data)
};

const downloadExcel = (filename, model = null ) => {
  setResponseType('blob');
  return httpClient.post(`${model}/to-excel`, {name: filename}).then(res => {
    setResponseType('json');
    return res
  });
};


const resetResponseType = () => {
  setResponseType('json');
};


const getInvoice = (invoice ) => {
  setResponseType('blob');
  // invoice.url = base/invoices
  return httpClient.get(`${URL_INVOICE}/${invoice.filename}`).then(res => {
    setResponseType('json');
    return res;
  });
}


const fetchOneInvoice = (id) => {
  return httpClient.get(`${URL_INVOICE}/detail/${id}`).then(res => res.data);
};


export {
  fetchAllParkings,
  fetchAllTown,
  fetchOneTown,
  fetchAllProvince,
  fetchOneProvince,
  downloadExcel,
  resetResponseType,
  fetchAllGroups,
  fetchAllPhonePrefix,
  getInvoice,
  fetchOneInvoice
  
};
